import { bombasColorsToToken, themeTokensToHexMap } from './colors';
/**
 * Converts semantic color names to their corresponding hex color values based on the selected theme.
 * This is used whenever we need the hex code or whenever we are unable to use CSS variables.
 *
 * @param colorName - semantic color name (e.g., 'bombasBlue', 'white', 'grey40')
 * @param theme - theme to use for color mapping ('legacy' or '2025-rebrand'). Defaults to '2025-rebrand'.
 * @returns Hex color value corresponding to the token in the selected theme or fallback color (--primary)
 */
export var convertColorToThemeHexCode = function (colorName, theme) {
    if (theme === void 0) { theme = '2025-rebrand'; }
    if (colorName === 'transparent')
        return 'transparent';
    // Maps semantic color names to design token.
    var tokenName = bombasColorsToToken[colorName] ||
        '--primary';
    var themeMap = themeTokensToHexMap[theme];
    return themeMap[tokenName] || '#223859';
};
export default {};
